import { style } from '@vanilla-extract/css';

export const section = style({
  backgroundColor: 'var(--post-section-background-color, transparent)',
  marginTop: 'var(--post-section-margin-top, 0px)',
  marginLeft: 'var(--post-section-margin-left, 0px)',
  marginRight: 'var(--post-section-margin-right, 0px)',
  marginBottom: 'var(--post-section-margin-bottom, 0px)',
  paddingTop: 'var(--post-section-padding-top, 0px)',
  paddingLeft: 'var(--post-section-padding-left, 0px)',
  paddingRight: 'var(--post-section-padding-right, 0px)',
  paddingBottom: 'var(--post-section-padding-bottom, 0px)',
  borderColor: 'var(--post-section-border-color, transparent)',
  borderStyle: 'var(--post-section-border-style, solid)',
  borderTopWidth: 'var(--post-section-border-top-width, 0px)',
  borderRightWidth: 'var(--post-section-border-right-width, 0px)',
  borderBottomWidth: 'var(--post-section-border-bottom-width, 0px)',
  borderLeftWidth: 'var(--post-section-border-left-width, 0px)',
  borderTopLeftRadius: 'var(--post-section-border-top-left-radius, 0px)',
  borderTopRightRadius: 'var(--post-section-border-top-right-radius, 0px)',
  borderBottomRightRadius: 'var(--post-section-border-bottom-right-radius, 0px)',
  borderBottomLeftRadius: 'var(--post-section-border-bottom-left-radius, 0px)',
});
